import { useMemo } from 'react';
import { ClaimResponse as Claim } from '@sentara-health/sentara-api-hooks-core';
import { buildClaimsIndex, ClaimsIndex } from '../utils/ClaimsIndex';

/** Memoized  hook to build ClaimsIndex */
export function useClaimsIndex(rawClaims: Claim[]): ClaimsIndex {
  return useMemo<ClaimsIndex>(
    () => buildClaimsIndex(rawClaims),
    [rawClaims]
  );
}